import { useState } from "react";

export function useCategoryForm() {
    const [nameEn, setNameEn] = useState('');
    const [nameAr, setNameAr] = useState('');
    const [descriptionEn, setDescriptionEn] = useState('');
    const [descriptionAr, setDescriptionAr] = useState('');
    const [image, setImage] = useState('');
    const [majorIds, setMajorIds] = useState([]);

    return {
        nameEn, setNameEn,
        nameAr, setNameAr,
        descriptionEn, setDescriptionEn,
        descriptionAr, setDescriptionAr,
        image, setImage,
        majorIds, setMajorIds,
    };
}
